export class ThreadsUpdateReq{
    id:number;
    style:number;
    supplierName:number;
    tex:string;
    part:string;
    quality:string;
    colorCombo:string;
    colorCode:string;
    shadeNumber:string;
    constructor(id:number,style:number,supplierName:number,tex:string,quality:string,colorCombo:string,colorCode:string,shadeNumber:string){
        this.id = id;
        this.style = style;
        this.supplierName=supplierName;
        this.tex=tex;
        this.quality=quality;
        this.colorCombo=colorCombo;
        this.colorCode=colorCode;
        this.shadeNumber=shadeNumber;
    }
}